import { Lock } from "lucide-react";
import type { ReactNode } from "react";
import { RequireRole } from "@/lib/auth";
import { EmptyState } from "./EmptyState";

/**
 * Route-level gate for Manager+ surfaces (TNK-84). Renders `children` only for
 * managers/owners; everyone else sees a "managers only" notice instead of a
 * broken empty page. UX affordance only — the server routes enforce the role.
 */
export function ManagerOnly({ children }: { children: ReactNode }) {
  return (
    <RequireRole
      min="manager"
      fallback={
        <EmptyState
          icon={<Lock className="h-7 w-7" />}
          title="Managers only"
          description="This area is available to store managers and owners."
        />
      }
    >
      {children}
    </RequireRole>
  );
}
